import type { PhoneStatus } from '../types'

interface StatusConfig {
  label: string
  dot: string
  color: string
  bg: string
}

export const statusConfig: Record<PhoneStatus, StatusConfig> = {
  online: { label: 'Online', dot: 'bg-green-500', color: 'text-green-500', bg: 'bg-green-50 dark:bg-green-950/30' },
  offline: { label: 'Offline', dot: 'bg-gray-400', color: 'text-gray-400', bg: 'bg-gray-50 dark:bg-gray-900/30' },
  'in-call': { label: 'In Call', dot: 'bg-amber-500 animate-pulse', color: 'text-red-500', bg: 'bg-amber-50 dark:bg-amber-950/30' },
  reconnecting: { label: 'Reconnecting', dot: 'bg-yellow-500 animate-pulse', color: 'text-yellow-500', bg: 'bg-yellow-50 dark:bg-yellow-950/30' },
} as const
